import { useSelector } from '@/api/state';
import useLogout from '@/hooks/auth/useLogout';
import {
  Avatar,
  Button,
  FloatingTooltip,
  Tooltip,
  TooltipCore,
} from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import React, { FC } from 'react';

const UserLogoutSection: FC = () => {
  const myProfile = useSelector((state: any) => state.users.myProfile);
  const logout = useLogout();

  return (
    <div className="flex w-full items-center pt-4 pb-2 border-t">
      <Avatar
        placeholderInitials={`${myProfile.firstname[0]}${myProfile.lastname[0]}`}
        imgSrc={myProfile.avatarUrl}
      />

      <div className="typography:prose ml-3 w-0 flex-[1_1_0px] whitespace-nowrap transition-opacity">
        <p className="overflow-hidden text-ellipsis">
          {myProfile.firstname} {myProfile.lastname}
        </p>
        <Tooltip
          tooltipContent={myProfile.email}
          className="supporting-body !block overflow-hidden text-ellipsis"
        >
          {myProfile.email}
        </Tooltip>
      </div>

      <div>
        <FloatingTooltip>
          <Button
            className="!inline-flex"
            aria-label={'Log out'}
            size={'xs'}
            shape={'pill'}
            variant={'ghost'}
            colour={'black'}
            onClick={logout}
          >
            <UntitledIcon className="h-4 w-4" name="log-out-03.3" />
          </Button>

          <TooltipCore>Log out</TooltipCore>
        </FloatingTooltip>
      </div>
    </div>
  );
};

export default UserLogoutSection;
